export const exportFile = (response: BlobPart, fileTitle: string) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.download = fileTitle;
  link.click();
  window.URL.revokeObjectURL(url);
};
